<template>
  <div class="flex justify-center">
    <ul class="text-xs">
      <li>
        <nuxt-link :to="localePath('index')">{{$t('nav.top')}}</nuxt-link>
      </li>
      <li v-for="(page, index) in list" :key="index">
        <i class="material-icons">chevron_right</i>
        <nuxt-link
          v-if="index !== list.length - 1 && page.url"
          :to="localePath(page.url)"
        >
          {{$t(page.name)}}
        </nuxt-link>
        <span v-else>{{$t(page.name)}}</span>
      </li>
    </ul>
  </div>
</template>
<style lang="sass" scoped>
.material-icons
  @apply text-sm align-middle mr-2
ul
  @apply flex flex-wrap items-center justify-center
li
  @apply flex items-center ml-1 mr-2
  &:first-child
    @apply ml-0
  &:last-child
    @apply mr-0
    span
      display: inline-block
      white-space: nowrap
      max-width: 31vw
      overflow: hidden
      text-overflow: ellipsis
      @screen sm
        max-width: 20vw
</style>
<script>
export default {
  props: {
    list: {
      type: Array,
      default: []
    }
  }
};
</script>